import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../common/providers/AuthProvider";

const ProtectedRoute = ({ children }) => {
  const {
    isLogin: { flag, agent },
    accessToken,
  } = useAuthContext();
  const location = useLocation();

  if ((flag || agent) && accessToken) {
    return children;
  }

  return (
    <Navigate
      to="/unauthorized"
      state={{ from: location }}
      replace
    />
  );
};

export default ProtectedRoute;
